import React, { memo, useContext, useEffect, useReducer } from 'react';
import './css/ImagesComponent1.css';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { SRLWrapper } from 'simple-react-lightbox';
import { context } from '../../../../globalState/GlobalState';
import Spinner1 from '../../spinners/spinner1/Spinner1';
import { fetchLimitedPhotosByTagAPI } from '../../../apiCalls/PhotoAPICalls';
import { isValidString } from '../../../../catalog/Validity';
import PlaceholderComponent4 from '../../placeholderComponents/placeholderComponent4/PlaceholderComponent4';

const initialState = {
    photos: [],
    loadingSpinner: true,
};

function reducer(state, action) {
    switch (action.type) {
        case 'fetchPhotos':
            return { ...state, photos: action.photos };
        case 'setLoadingSpinner':
            return { ...state, loadingSpinner: action.loadingSpinner };
        default:
            return initialState;
    }
}

const ImagesComponent1 = (props) => {
    const { tagId } = props;
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        async function fetchImages() {
            if (isValidString(globalState.accountId) && isValidString(tagId)) {
                setState({ type: 'setLoadingSpinner', loadingSpinner: true });
                await fetchLimitedPhotosByTagAPI(globalState.accountId, tagId, 200, setState, enqueueSnackbar);
                setState({ type: 'setLoadingSpinner', loadingSpinner: false });
            }
        }
        fetchImages();
    }, []);

    const options = {
        buttons: {
            showFullscreenButton: false,
            showDownloadButton: false,
            showAutoplayButton: false,
        },
        // thumbnails: {
        //     showThumbnails: false,
        // },
    };

    return (
        <>
            <div className="images-component1-container m-l-30px m-r-50px">
                {state.loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                    <>
                        {state.photos.length > 0 ? (
                            <>
                                <SRLWrapper options={options}>
                                    {state.photos.map((photo) => {
                                        return (
                                            <a key={photo.id} href={photo.image}>
                                                <img className="images-component1-img curve-border-5px m-l-0 m-r-10px m-t-5px m-b-5px" src={photo.image} alt={photo.title ? photo.title : 'Gallery Image'} />
                                            </a>
                                        );
                                    })}
                                </SRLWrapper>
                            </>
                        ) : <PlaceholderComponent4 text="No Images Available" />}
                    </>
                )}
            </div>
        </>
    );
};

ImagesComponent1.propTypes = {
    tagId: PropTypes.string.isRequired,
};

export default memo(ImagesComponent1);
